import { SET_REWARD_CENTER_NOTIFICATION } from './types';
export var setRewardCenterNotification = function setRewardCenterNotification(value) {
  return {
    type: SET_REWARD_CENTER_NOTIFICATION,
    payload: value
  };
};